import { Component, Inject } from '@angular/core';
import { OfferSetTemplateBase } from '../offers-templates/offer-set-template-base.component';

@Inject(OfferSetTemplateBase)
@Component({
  selector: 'tyt-modern-offers',
  templateUrl: './modern-offers.component.html',
  styleUrls: ['./modern-offers.component.scss']
})
export class ModernOffersComponent extends OfferSetTemplateBase {
}
